module.exports = __webpack_public_path__ + "img/Deaminasevariants_E.a851fa0b.svg";